module.exports = __webpack_public_path__ + "media/images/booknow-img-114a474e32be417dc5c6fd50053157aa.png";